import { CookieWall } from "./CookieWall";
import React, { Component } from "react";
import styled from "styled-components";
import { Link } from "gatsby";

const StyledMoreInfoComponent = styled.div`
  background-color: #efefef;
  padding: 0.5rem;
`;
const StyledFooter = styled.div`
  padding: 0 0 0.5rem;
  margin: 0;
  height: 1rem;
  font-size: smaller;
`;
const StyledLeftFooterLink = styled.a`
  float: left;
  color: #999 !important;
`;
const StyledRightFooterLink = styled.a`
  float: right;
  color: #999 !important;
`;

/* eslint-disable */
class CookieWallComponent extends Component {
  render() {
    return (
      <CookieWall
        style={{ margin: "80px auto" }}
        location={this.props.location}
        ref={instance => {
          this.child = instance;
        }}
        content={(pageNumber, showCookieInfo, allowAdvertisingCookie) => {
          switch (pageNumber) {
            case 1:
              return (
                <div>
                  <h4>Cookies on this website</h4>
                  <p>
                    To help improve your browsing experience, we use cookies on
                    this website. Cookies enhance navigation and allow us to
                    develop our website. Cookies also allow Picnic and third
                    parties to follow your search and surf behavior.
                  </p>
                  {/*<p>*/}
                  {/*Want to know more about these cookies and what we do with*/}
                  {/*them?*/}
                  {/*<InlineLink onClick={() => this.child.toggleCookieInfo()}>*/}
                  {/*Click here for more information.*/}
                  {/*</InlineLink>*/}
                  {/*</p>*/}
                  {showCookieInfo && <CookieWallMoreInfo />}
                  <p>
                    By clicking 'OK, continue', you agree that cookies are
                    turned on and enabled. You also agree that we use
                    information collected by these cookies to tailor our
                    advertisements.
                  </p>
                  <p>
                    Under 'Customize settings' you can manage personal cookie
                    settings.
                  </p>
                  <button
                    className="cookie-button red"
                    onClick={() => this.child.setCookieSettings()}
                  >
                    OK, continue
                  </button>
                  <button
                    className="cookie-button grey"
                    onClick={() => {
                      this.child.toggleAdvertisingCookie();
                      this.child.togglePage();
                    }}
                  >
                    Customize settings
                  </button>
                  <StyledFooter>
                    <StyledLeftFooterLink href="https://picnic.app/nl/privacy">
                      Privacy policy
                    </StyledLeftFooterLink>
                    <StyledRightFooterLink href="https://picnic.app/nl/cookies">
                      Cookie policy
                    </StyledRightFooterLink>
                  </StyledFooter>
                </div>
              );
            case 2:
              return (
                <div>
                  <h4>Cookie settings</h4>
                  <p>
                    To help improve browsing experience, we use cookies on this
                    website. There are several types of cookies, and you decide
                    which ones we use.
                  </p>
                  <div>
                    <p>
                      <b>Functional cookies</b>
                      <input
                        className="cookie-checkbox"
                        type="checkbox"
                        checked
                        disabled
                      />
                    </p>
                    <p>
                      These cookies ensure that we provide a seamless browsing
                      experience. Your information remains anonymous and secret.
                    </p>
                  </div>
                  <div>
                    <p>
                      <b>Analytical cookies </b>
                      <input
                        className="cookie-checkbox"
                        type="checkbox"
                        checked
                        disabled
                      />
                    </p>
                    <p>
                      These cookies help us make improvements to our website.
                      The data collected with these cookies remains anonymous.
                    </p>
                  </div>
                  <div>
                    <p>
                      <b>Advertising cookies </b>
                      <input
                        id="ads-cookie"
                        className="cookie-checkbox"
                        type="checkbox"
                        checked={allowAdvertisingCookie}
                        onChange={() => {
                          this.child.toggleAdvertisingCookie();
                        }}
                      />
                    </p>
                    <p>
                      With these cookies, we keep track of how many and which of
                      our advertisements you have already seen on Picnic and
                      external websites. By using these cookies, we can show you
                      information that you'll find relevant and interesting.
                    </p>
                  </div>
                  {/*<p>*/}
                  {/*Want to know more about these cookies and what we do with*/}
                  {/*them?*/}
                  {/*<InlineLink*/}
                  {/*onClick={() => {*/}
                  {/*this.child.toggleCookieInfo();*/}
                  {/*}}*/}
                  {/*>*/}
                  {/*Click here for more information.*/}
                  {/*</InlineLink>*/}
                  {/*</p>*/}
                  {showCookieInfo && <CookieWallMoreInfo i18n={i18n} />}
                  <p>
                    By clicking on 'Save and continue', you agree that the
                    selected cookies are turned on and enabled.
                  </p>
                  <button
                    className="cookie-button red"
                    onClick={() => this.child.setCookieSettings()}
                  >
                    Save and continue
                  </button>
                  <button
                    className="cookie-button grey"
                    onClick={() => {
                      this.child.toggleAdvertisingCookie();
                      this.child.togglePage();
                    }}
                  >
                    Cancel
                  </button>
                  <StyledFooter>
                    <StyledLeftFooterLink href="https://picnic.app/nl/privacy">
                      Privacy policy
                    </StyledLeftFooterLink>
                    <StyledRightFooterLink href="https://picnic.app/nl/cookies">
                      Cookie policy
                    </StyledRightFooterLink>
                  </StyledFooter>
                </div>
              );
            default:
              return;
          }
        }}
      />
    );
  }
}

export default CookieWallComponent;

class CookieWallMoreInfo extends Component {
  render() {
    return (
      <StyledMoreInfoComponent>
        <h4>Dummytext</h4>
        <p>Dummytext</p>
        <h4>Dummytext</h4>
        <p>Dummytext</p>
        <p>
          <ul class="bullets">
            <li>Dummytext</li>
            <li>Dummytext</li>
            <li>Dummytext</li>
            <li>Dummytext</li>
            <li>Dummytext</li>
          </ul>
        </p>
        <p>
          Dummytext
          <Link to={"/"}>Dummytext</Link>
          Dummytext
        </p>
        <h4>Dummytext</h4>
        <p>Dummytext</p>
        <p>Dummytext</p>
        <p>
          <ul class="bullets">
            <li>Dummytext</li>
            <li>Dummytext</li>
            <li>Dummytext</li>
            <li>Dummytext</li>
            <li>Dummytext</li>
            <li>Dummytext</li>
          </ul>
        </p>
        <p>Dummytext</p>
        <p>Dummytext</p>
        <p>
          Dummytext
          <Link to={"/"}>Dummytext</Link>
          Dummytext
        </p>
        <h4>Dummytext</h4>
        <p>Dummytext</p>
        <p>Dummytext</p>
        <p>
          <ul class="bullets">
            <li>Dummytext</li>
            <li>Dummytext</li>
            <li>Dummytext</li>
          </ul>
        </p>
        <p>Dummytext</p>
        <p>
          Dummytext
          <Link to={"/"}>Dummytext</Link>
          Dummytext
        </p>
        <h4>Dummytext</h4>
        <p>Dummytext</p>
        <p>
          Dummytext
          <a href="https://support.apple.com/en-ca/HT202074">Dummytext</a>
          Dummytext
          <a href="https://support.google.com/ads/answer/2662922?hl=nl">
            Dummytext
          </a>
          Dummytext
        </p>
        <p>Dummytext</p>
        <h4>Dummytext</h4>
        <p>Dummytext</p>
        <p>Dummytext</p>
        <p>Dummytext</p>
        <p>Dummytext</p>
        <p>Dummytext</p>
        <p>
          <ul class="bullets">
            <li>
              <a href="https://support.google.com/chrome/answer/95647?hl=nl">
                Dummytext
              </a>
            </li>
            <li>
              <a href="https://support.microsoft.com/nl-nl/help/10607/microsoft-edge-view-delete-browser-history">
                Dummytext
              </a>
            </li>
            <li>
              <a href="https://support.microsoft.com/nl-nl/help/17442/windows-internet-explorer-delete-manage-cookies">
                Dummytext
              </a>
            </li>
            <li>
              <a href="https://support.apple.com/kb/ph21411?locale=nl_NL">
                Dummytext
              </a>
            </li>
            <li>
              <a href="https://support.mozilla.org/nl/kb/navigatiegeschiedenis-cookies-opgeslagen-gegevens-wissen">
                Dummytext
              </a>
            </li>
          </ul>
        </p>
        <h4>Dummytext</h4>
        <p>
          Dummytext
          <Link to={"/"}>Dummytext</Link>
          Dummytext
          <Link to={"/"}>Dummytext</Link>
        </p>
      </StyledMoreInfoComponent>
    );
  }
}
